import { TRoleNames } from 'app/railways/domains/access/features/roles/roles';
import { filterRequiredRoles } from 'app/railways/domains/access/modules/check-roles';

import { TEntityGridExtraFilter } from '../../core';

type EntityGridExtraFiltersParams = {
  extraFilters: TEntityGridExtraFilter[];
  userRoles: TRoleNames[];
};
export class EntityGridExtraFilters {
  private _filters: TEntityGridExtraFilter[] = [];

  get filters() {
    return this._filters;
  }

  constructor(params: EntityGridExtraFiltersParams) {
    this._filters = filterRequiredRoles(params.extraFilters, params.userRoles);
  }
}
